import { css } from '@emotion/react';
import { useMemo } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { textInputSizes } from './constants';
const borderWidth = 1;
const errorHeight = 22;
const activeLabelOffset = 0;
const inputHeights = {
    [textInputSizes.medium]: 48,
    [textInputSizes.small]: 40,
};
const errorMessageStyles = css `
  ${theme.typeStyles.bodySmallStyles}
  color: ${theme.colors.negative800};
  margin-top: ${theme.spacing.base};
  width: 100%;
`;
const errorStyles = css `
  border-color: ${theme.colors.negative800};
`;
const inputValueStyles = css `
  ${theme.typeStyles.bodyMediumStyles}
`;
// TODO: Do we need important because of App-Renderer's global styles?
const horizontalSpacingStyles = css `
  padding-left: ${theme.spacing.x3} !important; /* stylelint-disable-line declaration-no-important */
  padding-right: ${theme.spacing.x3} !important; /* stylelint-disable-line declaration-no-important */
`;
const inputStyles = css `
  ${inputValueStyles}
  ${horizontalSpacingStyles}
  align-self: center;
  background-color: transparent;
  display: block;
  height: 100%;
  width: 100%;

  &:focus {
    outline: 0;
  }

  &:disabled {
    background: ${theme.colors.gray200};
    color: ${theme.colors.gray500};
  }
`;
const activeLabelVariationStyles = {
    [textInputSizes.medium]: css `
    padding-bottom: ${theme.spacing.none};
    padding-top: ${theme.spacing.base};
  `,
    [textInputSizes.small]: css `
    padding-bottom: ${theme.spacing.none};
    padding-top: calc(${theme.spacing.base} / 2);
  `,
};
const labelVariationStyles = {
    [textInputSizes.medium]: css `
    padding-bottom: ${theme.spacing.x3};
    padding-top: ${theme.spacing.x3};
  `,
    [textInputSizes.small]: css `
    padding-bottom: calc(${theme.spacing.base} / 2);
    padding-top: ${theme.spacing.x2};
  `,
};
const placeholderContainerStyles = css `
  align-items: center;
  display: flex;
  height: 100%;
  pointer-events: none;
  position: absolute;
  width: 100%;
`;
const useErrorSpacingStyles = ({ isErrorSpacingVisible, size, }) => (useMemo(() => (isErrorSpacingVisible
    && css `
        min-height: ${styleUtils.rem(inputHeights[size] + errorHeight)};
      `), [
    isErrorSpacingVisible,
    size,
]));
const useInputContainerStyles = ({ isDisabled = false, isLabelVisible = false, }) => (useMemo(() => (css `
        height: 100%;
        overflow: hidden;
        position: relative;
        ${!isLabelVisible && css `
          display: flex;
        `}
        ${isDisabled && css `
          background: ${theme.colors.gray200};
          color: ${theme.colors.gray500};
        `}
      `), [
    isDisabled,
    isLabelVisible,
]));
const counterStyles = css `
  flex-grow: 1;
  text-align: right;
`;
const useLabelStyles = ({ isValueVisible, size, }) => {
    const activeLabelStyles = useMemo(() => (css `
        ${theme.typeStyles.bodyExtraSmallStyles}
        ${activeLabelVariationStyles[size]}
        color: ${theme.colors.gray600};
        display: flex;
        pointer-events: none;
        transform: translateY(${styleUtils.rem(activeLabelOffset)});
      `), [
        size,
    ]);
    return (useMemo(() => (css `
          ${inputValueStyles}
          ${horizontalSpacingStyles}
          ${labelVariationStyles[size]}
          background-color: transparent;
          box-sizing: border-box;
          display: block;
          position: absolute;
          top: 0;
          white-space: nowrap;
          width: 100%;
          ${styleUtils.transition('all')}

          input:focus ~ &,
          textarea:focus ~ & {
            ${activeLabelStyles}
          }

          input:disabled ~ &,
          textarea:disabled ~ & {
            color: ${theme.colors.gray500};
          }

          ${isValueVisible && activeLabelStyles}
        `), [
        activeLabelStyles,
        isValueVisible,
        size,
    ]));
};
const usePlaceholderContentStyles = ({ isLabelVisible, isValueVisible, size, }) => (useMemo(() => (css `
        ${inputValueStyles}
        ${horizontalSpacingStyles}
        ${labelVariationStyles[size]}
        border-top: ${styleUtils.rem(borderWidth)} solid transparent;
        color: ${theme.colors.gray600};
        cursor: text;
        width: 100%;

        ${isLabelVisible && css `
          opacity: 0;
          ${styleUtils.transition('opacity')}

          input:focus ~ div &,
          textarea:focus ~ div & {
            opacity: 1;
          }
        `}
        ${isValueVisible && css `
          display: none;
        `}
      `), [
    isLabelVisible,
    isValueVisible,
    size,
]));
export { borderWidth, counterStyles, errorMessageStyles, errorStyles, inputHeights, inputStyles, placeholderContainerStyles, useErrorSpacingStyles, useInputContainerStyles, useLabelStyles, usePlaceholderContentStyles, };
